import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '卡券名称',
            dataIndex: 'couponName',
            key: 'couponName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '名称备注',
            dataIndex: 'couponDesc',
            key: 'couponDesc',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '卡券类型',
            dataIndex: 'couponTypeDesc',
            key: 'couponTypeDesc',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发放时间',
            dataIndex: 'issueStartTime',
            key: 'issueStartTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => (
                <div>
                    <div>{text}</div>
                    <div>{record.issueEndTime}</div>
                </div>
            )
        },
        {
            title: '库存',
            dataIndex: 'leftNum',
            key: 'leftNum',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发放状态',
            dataIndex: 'issueStatusDesc',
            key: 'issueStatusDesc',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '启用状态',
            dataIndex: 'statusDesc',
            key: 'statusDesc',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }
    ];

    _takeDataSource = (data) => {
        if (Array.isArray(data)) {
            return data;
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        const disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', record)}>查看详情</div>
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
            </div>
        );
    };

    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    columns={this._columns()}
                    rowKey={(r) => r.id}
                    rowSelection={rowSelection}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

